<template>
     <v-theme-provider>
          <v-card class="mx-auto elevation-5" color="white">
               <v-row no-gutters>
                    <v-card-text>
                         <v-col cols="12" md="12" sm="12">
                              <v-list>
                                   <template v-for="(item, index) in list">
                                        <v-list-item :key="index">
                                             <v-list-item-content>
                                                  <v-list-item-title
                                                       class="primary--text"
                                                       style="font-size: 1.5em"
                                                       v-html="item.name"
                                                  ></v-list-item-title>
                                                  <v-list-item-subtitle
                                                       style="font-size: 1em"
                                                       class="text-wrap"
                                                       v-html="item.description"
                                                  ></v-list-item-subtitle>
                                             </v-list-item-content>
                                             <v-list-item-action>
                                                  <v-list-item-action-text
                                                       v-text="item.price"
                                                       class="font-weight-bold"
                                                       style="font-size: 2em"
                                                  ></v-list-item-action-text>
                                             </v-list-item-action>
                                        </v-list-item>
                                        <v-divider :key="index"></v-divider>
                                   </template>
                              </v-list>
                         </v-col>
                    </v-card-text>
               </v-row>
          </v-card>
     </v-theme-provider>
</template>

<script>
export default {
     name: 'BaseFoodMenu',
     props: {
          dark: Boolean,
          list: Array,
          color: {
               type: String,
               default: 'primary',
          },
     },
     data: () => ({}),
}
</script>
